module.exports = __webpack_public_path__ + "media/images/malvinas/iso_ok-c637e61303d89a3d3758bc844a1e4b93.svg";